import type { userType } from '@constants';
import type { Timezone, User, UserType } from '@types';
import type React from 'react';

export interface UpdateUserV3Payload {
  _id?: string;
  id?: string;
  name: string;
  email: string;
  password?: string;
  userType: Array<{ type: userType }>;
  timezone: Timezone;
  organizationId: string;
  sdrId?: string | null;
  profilePicture: string;
}

export interface UsersListDto {
  data: User[];
  totalPages?: number;
  totalCount?: number;
  pageNumber?: number;
}

export interface SelectOption {
  value: string;
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
}

export interface UserForm {
  id?: string;
  name: string;
  email: string;
  organizationId?: string;
  sdrId?: string | null;
  timezone?: string | null;
  profilePicture?: string | null;
  userType: UserType[];
  password?: string;
  confirmPassword?: string;
  adminPassword?: string;
  newPassword?: string;
}

export interface SdrUser {
  id: string;
  name: string;
  email: string;
  userType: UserType[];
  orgName: string;
  organizationId: string;
  timezone: string;
}
